import { Link } from 'react-router-dom'
import { ArrowLeft } from '@phosphor-icons/react'

import { ListWhen } from '@/main/features/List/components/ListWhen'

import { ItemCondensed } from '@/main/features/Item/components/ItemCondensed/ItemCondensed'
import { useCart } from './SidebarCartLayout'
import { ListSummary } from '@/main/features/List/components/ListSummary/ListSummary'

export function SidebarCartList() {
  const { list, isReady } = useCart()

  return (
    <div className="twc-flex twc-w-full twc-max-w-sm twc-flex-col twc-items-stretch twc-gap-2">
      <div className="twc-bg-white twc-shadow-lg twc-p-4 twc-border twc-border-slate-100 twc-rounded min-h-[10rem] dark:twc-bg-slate-800/50 dark:twc-border-gray-800">
        <h5 className="twc-font-bold twc-mb-2">Props</h5>
        <ListWhen isReady={isReady ?? false} isEmpty={!list?.itemIds || list.itemIds.length === 0}>
          {list && <ItemCondensed ids={list.itemIds} />}
        </ListWhen>
      </div>

      {list && (
        <div className="twc-prose twc-prose-sm twc-py-4 twc-px-4 twc-w-full xs:twc-w-3/4 twc-ml-auto">
          <ListSummary listId={list.id} />
        </div>
      )}

      <Link
        to={`/${list?.id}`}
        className="twc-inline-flex twc-text-sm xl:twc-text-base twc-items-center twc-gap-1 twc-ml-auto twc-mt-4 twc-mr-4"
      >
        <ArrowLeft size={18} /> Make Changes (back to summary)
      </Link>
    </div>
  )
}
